/*
 * @Description: In User Settings Edit
 * @Author: yangkq
 * @LastEditors: yangkq
 * @Date: 2019-03-11 14:11:50
 * @LastEditTime: 2019-03-19 10:05:39
 */
import request from "@/plugins/axios/request";
// 获取产品介绍list数据
export function queryproductdesc(id) {
    return request({
        url: "/productdesc/queryproductdesc",
        method: "post",
        data: { categoryId: id, platform: "1" }
    });
}
// 获取产品介绍list数据
export function queryproductbanner(id) {
    return request({
        url: "/productdesc/queryproductbanner",
        method: "post",
        data: { categoryId: id, platform: "1" }
    });
}
// 获取产品介绍list数据
export function querybycategoryidesc(id) {
    return request({
        url: "/productdesc/querybycategoryidesc",
        method: "post",
        data: { categoryId: id, platform: "1" }
    });
}
// 获取增值服务下面文章通过categoryid
export function queryproductdescbyid(id) {
    return request({
        url: "/productdesc/queryproductdescbyid",
        method: "post",
        data: { categoryId: id, platform: "1" }
    });
}
// 首页获取主营产品
export function queryhomecategoryid(id) {
    return request({
        url: "/productdesc/queryhomecategoryid",
        method: "post",
        data: { categoryId: id, platform: "1" }
    });
}
